/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getIntelligentApplets} from '../api'

 export const useQueryGetIntelligentApplets = createReactQueryHook('getIntelligentApplets', getIntelligentApplets)
